/**
 * @file       SideNav.css
 * @author     Alex Huctwith <alex@kingsds.network>
 *
 * @date       April 2022
 *
 *             Style for the side nav component
 */

#sidebar {
  z-index: 10;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0;
  padding: 0;
  background: #10243c;
  background: linear-gradient(
    var(--gradient-hue-top) 0%,
    var(--gradient-hue-bottom) 100%
  );
  position: fixed;
  width: 250px;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  box-shadow: 2px solid black;
}

.nav-overlay {
  z-index: 9;
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  backdrop-filter: blur(5px);
}

@media only screen and (max-width: 1000px) {
  .nav-open {
    display: initial;
  }
}

#sidebar ul {
  position: relative;
  padding: 0;
  margin: 0;
  display: block;
  justify-content: center;
  align-items: center;
  list-style: none;
  background: transparent;
  background-size: contain;
}

#sidebar li > :is(a, button) {
  width: 100%;
  display: flex;
  gap: 10px;
  align-items: center;
  padding-left: 0.5em;
  padding-top: 0.6em;
  padding-bottom: 0.6em;
  font-weight: 400;
  text-decoration: none;
  transition: color 0.2s linear;
  background: none;
  color: #ccc;
  fill: #ccc;
  cursor: pointer;
  border: none;
  height: auto;

  /* define left border for active color to prevent padding */
  border-left: solid 6px transparent;
  border-top: solid 1px #ccc;
}

#sidebar li > :is(a, button):focus-visible {
  outline: none;
  background-color: rgba(255 255 255 0.085);
}

/**
 * NOTE: this sizing applies to the wrapper of the svg, not the svg itself. 
 *       The way we currently use svgs doesn't allow the svg to be sized using CSS,
 *       instead the width, height and viewBox attributes of the svg define its size.
 */
#sidebar li > :is(a, button) svg {
  height: 20px;
  width: 20px;
}

#sidebar LI > A > IMG[src*="icons/lucide"][src$=".svg"] {
  filter: invert(50%) sepia(100%) hue-rotate(90deg) saturate(0%) brightness(130%);
  height: 20px;
  width: 20px;
}

#sidebar LI > A.active,
#sidebar LI:where(:hover, .highlight) > A  {
  & > IMG[src*="icons/lucide"][src$=".svg"] {
    filter: invert(50%) sepia(100%) hue-rotate(90deg) saturate(0%) brightness(160%);
  }
}

#sidebar li > :is(a, button) span {
  padding-top: 2px;
}

#sidebar LI.highlight {
  outline: 2px solid #ff0;
  outline-offset: -2px;
}

#sidebar LI.highlight > :is(A, BUTTON),
#sidebar LI           > :is(A, BUTTON):hover {
  color: #fff;
  fill: #fff;
}

#sidebar li > a.active {
  color: #fff;
  fill: #fff;
  background-color: #fff3;
  border-left: solid 6px var(--primary-hue-main);
  font-weight: bold;
}

#sidebar .logo {
  margin: 1.5em 0 4em 1em;
  width: 80%;
}

.sidebar-links {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}

.bottomBorder {
  border-bottom: solid 1px #ccc;
}

.close-menu {
  display: none;
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 0;
}

.close-menu img {
  height: 24px;
  width: 24px;
  filter: brightness(0) saturate(100%) invert(58%) sepia(6%) saturate(9%)
    hue-rotate(331deg) brightness(94%) contrast(85%);
  transition: filter linear 0.1s;
}

.close-menu img:hover {
  filter: brightness(0) saturate(100%) invert(100%) sepia(100%) saturate(0%)
    hue-rotate(49deg) brightness(103%) contrast(103%);
}

.xIcon:hover {
  color: #fff;
  transition: 150ms;
}

.powered-by-dcp {
  width: 100%;
  text-align: center;
  margin: 1em 0;
}

.powered-by-dcp > span {
  font-size: 0.75rem;
  color: #fff;
  opacity: 0.5;
}

.powered-by-dcp > img {
  margin: 7px auto 0;
  width: 35px;
  display: block;
}

@media only screen and (max-width: 1000px) {
  #sidebar {
    width: 300px;
    left: -300px;
    transition: all 150ms;
    -webkit-transition: all 150ms;
  }

  #sidebar.opened {
    left: 0;
    box-shadow: 0 2px 10px #1e1e1e;
  }

  .close-menu {
    display: block;
  }
}

/* Hide the test-features by default, enable when BODY[test-features="enabled"] */
LI[test-feature] {
  display: none;
}

BODY[test-features="enabled"] LI[test-feature] {
  display: initial;
}
